import { useEffect, useState } from 'react';

/** Id del contenedor que el Header expone para que una vista inyecte sus acciones. */
export const HEADER_SLOT_ID = 'header-actions-slot';

/**
 * Devuelve el nodo del slot de acciones del header para portalear controles
 * propios de la vista (ej. Azar / Buscar en DetailView).
 *
 * El nodo recién existe después del commit — Header y la vista montan en el
 * mismo render — así que se resuelve en un effect y el portal aparece en el
 * segundo pase.
 */
export function useHeaderSlot(): HTMLElement | null {
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setNode(document.getElementById(HEADER_SLOT_ID));
  }, []);

  return node;
}
